import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../store';
import * as SurveyStore from '../store/Survey';
import getLangTranslation from '../common/lang-trans';

import SurveyHeader from '../components/survey/SurveyHeader';
import SurveyStart from "../components/survey/SurveyStart";
import SurveyLanguage from "../components/survey/SurveyLanguage";
import SurveyEndnote from "../components/survey/SurveyEndnote";
import SurveyQuestionnaire from "../components/survey/SurveyQuestionnaire";

// At runtime, Redux will merge together...
type SurveyProps =
    SurveyStore.DataState // ... state we've requested from the Redux store
    & typeof SurveyStore.actionCreators // ... plus action creators we've requested
    & RouteComponentProps<{ surveyCode: string }>; // ... plus incoming routing parameters

class Campaign extends React.PureComponent<SurveyProps> {

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    // This method is called when the route parameters change
    public componentDidUpdate() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {
        const surveyCode = this.props.match.params.surveyCode || '';
        this.props.RequestSurvey(surveyCode);
    }

    public render() {
        const heading = this.props.survey.name || this.props.survey.title || this.props.survey.titleEn || '';

        return (
            <React.Fragment>
                <SurveyHeader></SurveyHeader>
                <div className="main-row">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <h1 className="mb-4">{heading}</h1>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div className="d-flex flex-row-reverse">
                            </div>
                        </div>
                    </div>
                    {this.renderStepComponent()}
                </div>
            </React.Fragment>
        );
    }

    private renderStepComponent() {
        const langTransEN = getLangTranslation('en');
        const langTransFR = getLangTranslation('fr');

        if (this.props.survey) {
            switch (this.props.step) {
                case -1:
                    return (<><p>{ langTransEN.UnableToLoading }</p><p>{ langTransFR.UnableToLoading }</p></>);
                case 0:
                    return (<><p>{ langTransEN.LoadingPleaseWait }</p><p>{ langTransFR.LoadingPleaseWait }</p></>);
                case 1:
                    return (<SurveyLanguage></SurveyLanguage>);
                case 2:
                    return (<SurveyStart 
                                moveNextStep={ this.props.MoveNextStep }
                                survey={ this.props.survey }
                                language={ this.props.language }></SurveyStart>);
                case 3:
                    return (<SurveyQuestionnaire
                                errorInSubmit={ this.props.errorInSubmit }
                                isSubmitted={ this.props.isSubmitted }
                                survey={ this.props.survey }
                                language={ this.props.language }
                                SubmitSurvey={ this.props.SubmitSurvey }
                                SetValidationStatus={ this.props.SetValidationStatus }
                                SetValidationStatusAndValue={ this.props.SetValidationStatusAndValue }></SurveyQuestionnaire>);
                case 4:
                    return (<SurveyEndnote
                                survey={ this.props.survey }
                                ></SurveyEndnote>);
            }
        } else {
            return (
                <p>{ langTransEN.UnableToLoading } / { langTransFR.UnableToLoading }</p>
            );
        }

    }

}

export default connect(
    (state: ApplicationState) => state.surveyStore,
    SurveyStore.actionCreators
)(Campaign as any);
